import { jsxs, jsx } from "react/jsx-runtime";
import { BooleanQuestion, BooleanCross, BooleanCheck } from "../../../common/assets/icons/Boolean.js";
import CellContainer, { computeCanEdit } from "../CellContainer.js";
import { Label, ValueAdded, ValueRequiresDecision } from "../Styles.js";
import { isBoolean } from "../../../utils/utils.js";
import { ContentWrapper, ContentInner, SwitchWrapper, Switch, Knob, KnobIcon } from "./Styles.js";
const getLabel = (value, columnConfig) => {
  var _a;
  const labelFromOptions = Array.isArray(columnConfig == null ? void 0 : columnConfig.options) ? (_a = columnConfig == null ? void 0 : columnConfig.options.find((o) => o.value === value)) == null ? void 0 : _a.label : void 0;
  return labelFromOptions ?? (value == null ? void 0 : value.toString()) ?? "";
};
const BooleanSwitch = ({
  value,
  label,
  checked,
  mutated,
  error,
  warning,
  disabled,
  removed,
  added,
  diff,
  canHide,
  onClick,
  unresolvedDecision
}) => {
  const hasNonBooleanValue = !isBoolean(value);
  const hidden = !value && hasNonBooleanValue && canHide;
  return /* @__PURE__ */ jsx(
    ContentWrapper,
    {
      readOnly: disabled,
      removed,
      diff,
      onClick: disabled ? void 0 : onClick,
      className: hidden ? "hidden-content" : void 0,
      role: "toggle",
      "aria-label": "toggle",
      children: /* @__PURE__ */ jsxs(ContentInner, { children: [
        /* @__PURE__ */ jsx(SwitchWrapper, { children: /* @__PURE__ */ jsx(
          Switch,
          {
            role: "checkbox",
            "aria-checked": checked,
            checked,
            error,
            warning,
            removed,
            children: /* @__PURE__ */ jsx(Knob, { role: "knob", checked, children: /* @__PURE__ */ jsx(
              KnobIcon,
              {
                error,
                warning,
                checked,
                removed: removed && !unresolvedDecision,
                children: hasNonBooleanValue ? /* @__PURE__ */ jsx(BooleanQuestion, {}) : !checked ? /* @__PURE__ */ jsx(BooleanCross, {}) : /* @__PURE__ */ jsx(BooleanCheck, {})
              }
            ) })
          }
        ) }),
        /* @__PURE__ */ jsxs(Label, { mutated, title: label.length > 35 ? label : void 0, children: [
          !unresolvedDecision && (added ? /* @__PURE__ */ jsx(ValueAdded, { children: label }) : label),
          unresolvedDecision && /* @__PURE__ */ jsx(ValueRequiresDecision, { children: label })
        ] })
      ] })
    }
  );
};
const Renderer = ({
  exitSelectionState,
  ...props
}) => {
  var _a, _b, _c, _d, _e;
  const { status, active, mutated, cell, isDiffView } = props;
  const cellValue = cell == null ? void 0 : cell.value;
  const diffValue = cell == null ? void 0 : cell.diffValue;
  const valueChanged = (cellValue ?? "").toString() !== (diffValue ?? "").toString();
  const cellLabel = getLabel(cellValue, props.columnConfig);
  const diffLabel = getLabel(diffValue, props.columnConfig);
  const showDiff = isDiffView && (valueChanged || cellLabel !== diffLabel);
  const unresolvedDecision = ((_a = cell == null ? void 0 : cell.metadata) == null ? void 0 : _a.requiresDecision) && !((_b = cell == null ? void 0 : cell.metadata) == null ? void 0 : _b.acceptedValue);
  const acceptedValue = (_c = cell == null ? void 0 : cell.metadata) == null ? void 0 : _c.acceptedValue;
  const value = showDiff ? diffValue : cellValue;
  const label = showDiff ? diffLabel : cellLabel;
  const checked = value === true;
  const added = cellValue === void 0 && !cellLabel && showDiff;
  const editingEnabled = computeCanEdit(props);
  const handleClick = (event) => {
    if (!editingEnabled) {
      return;
    }
    event.preventDefault();
    if (exitSelectionState)
      exitSelectionState();
    const newValue = !checked;
    props.onUpdateCell(newValue);
  };
  const handleEnterOrSpace = () => {
    if (!editingEnabled) {
      return;
    }
    const newValue = !checked;
    props.onUpdateCell(newValue);
  };
  return /* @__PURE__ */ jsxs(
    CellContainer,
    {
      ...props,
      isBoolean: true,
      tooltipDisabled: active,
      onEnterOrSpace: handleEnterOrSpace,
      editorDisabled: true,
      children: [
        showDiff && !added && /* @__PURE__ */ jsx(
          BooleanSwitch,
          {
            value: cellValue,
            label: cellLabel,
            checked: cellValue === true,
            removed: !acceptedValue && !unresolvedDecision || acceptedValue === "diff" || ((_d = cell.config) == null ? void 0 : _d.markedForDeletion),
            added: acceptedValue === "source",
            disabled: true,
            diff: true,
            unresolvedDecision
          }
        ),
        /* @__PURE__ */ jsx(
          BooleanSwitch,
          {
            value,
            label,
            checked,
            error: status.error,
            warning: status.warning,
            disabled: !editingEnabled,
            mutated,
            canHide: !showDiff,
            diff: showDiff,
            added: showDiff && !unresolvedDecision && acceptedValue !== "source",
            removed: acceptedValue === "source" || ((_e = cell == null ? void 0 : cell.config) == null ? void 0 : _e.markedForDeletion),
            onClick: handleClick,
            unresolvedDecision
          }
        )
      ]
    }
  );
};
Renderer.displayName = "Boolean";
export {
  Renderer as default
};
